import React from 'react'
import TranslationLabel from '../../../../core/components/TranslationLabel'
import { Typography, Button, Modal, makeStyles, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  modalWrapper: {
    backgroundColor: 'white',
    width: '500px',
    maxWidth: '100%',
    margin: 'auto',
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',
    padding: '25px',
    paddingTop: 10,
    textAlign: 'center',
    outline: 'none',
  },
  openOrderModalLine: {
    cursor: 'pointer',
    margin: 5,
    textDecoration: 'underline',
  },
}))

const ReservationsModal = (props) => {
  const { reservationsProduct, setReservationsModal } = props
  const classes = useStyles()

  const formatDate = (dateString) => {
    if (!dateString) return ''
    const date = new Date(dateString)
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
  }

  return (
    <Modal
      open={!!reservationsProduct}
      onClose={() => setReservationsModal(undefined)}>
      <div className={classes.modalWrapper}>
        <Typography
          style={{ marginBottom: 25, marginTop: 15 }}
          variant='h5'>
          <TranslationLabel
            name='reservationBreakdownHeadline'
            variables={[reservationsProduct?.reservations.length]}
          />
        </Typography>
        {reservationsProduct && (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center"><TranslationLabel name="reservationQuantity" /></TableCell>
                <TableCell align="center"><TranslationLabel name="reservationFromDate" /></TableCell>
                <TableCell align="center"><TranslationLabel name="reservationToDate" /></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reservationsProduct.reservations
                .slice()
                .sort((a, b) => new Date(a.fromDate) - new Date(b.fromDate))
                .map((reservation, idx) => (
                  <TableRow key={idx}>
                    <TableCell align="center">{reservation.quantity}</TableCell>
                    <TableCell align="center">{formatDate(reservation.fromDate)}</TableCell>
                    <TableCell align="center">{formatDate(reservation.toDate)}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        )}
        <Button
          style={{ marginTop: 20 }}
          variant='outlined'
          color='primary'
          onClick={() => setReservationsModal(undefined)}>
          <TranslationLabel name='ok' />
        </Button>
      </div>
    </Modal>
  )
}

export default ReservationsModal
